import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import * as fromBillingSharedFeature from './common.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromBillingSharedFeature.billingSharedFeatureKey,
      fromBillingSharedFeature.billingSharedFeatureReducer
    )
  ]
})
export class BillingSharedStateModule {}
